
import Kefir from 'kefir'
import {fromProgram} from './api'

Kefir.sequentially(100, [1, 2, 3])
  .flatMap(fromProgram('node', [__dirname + '/../example/inc.js']))
  .log()
